// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bei_a bhf_tp","StrollerBoxWidget__imageCounselling":"bei_b bhf_ke"};